// address?.id || "" OR address.id ?? ""
export const getValueOrEmpty = <T>(arg1: T | undefined): T | string => {
  if (arg1) {
    return arg1;
  }
  return "";
};

// audio?.thumbnail ? audio.thumbnail : musicIcon
export const getValueOrDefault = <T1, T2>(
  arg1: T1 | undefined,
  arg2: T2
): T1 | T2 => {
  if (arg1) {
    return arg1;
  }
  return arg2;
};

// {isEdit ? "Save Changes" : "Save"}
// item.purchase_type === "purchase" (return true, false)
export const getOptionBasedOnCondition = <T1, T2, T3>(
  arg1: T1,
  arg2: T2,
  arg3: T3
): T2 | T3 => {
  if (arg1) {
    return arg2;
  }
  return arg3;
};

export const anyTrue = (args: boolean[]) => {
  for (const arg of args) {
    if (arg) {
      return true;
    }
  }
  return false;
};

export const getNumberValue = (
  arg1: number | undefined,
  arg2: number
): number => {
  if (arg1 !== undefined) {
    return arg1;
  }

  return arg2;
};
